import React from 'react';
import { useTranslation } from 'react-i18next';

import './steps-overview.scss';

const StepsOverview: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const steps = [
    t('STEP_OVERVIEW.SELECT_TOKEN'),
    t('STEP_OVERVIEW.SCAN_QR_CODE'),
    t('STEP_OVERVIEW.PROCEED_WITH_PAYMENT'),
  ];

  return (
    <section className="steps-overview">
      <ol className="steps-overview-list">
        {steps.map((step) => (
          <li
            key={step}
            className="steps-overview-item"
          >
            {step}
          </li>
        ))}
      </ol>
    </section>
  );
};

export default StepsOverview;
